import Page from './internal/Page.tsx';
import PageContent from './internal/PageContent.tsx';
import PageHeader from './internal/PageHeader.tsx';
import PageHeaderTitle from './internal/PageHeaderTitle.tsx';
import PageHeaderBreadcrumb from './internal/PageHeaderBreadcrumb.tsx';
import PageHeaderButton, { PageHeaderIconButton } from './internal/PageHeaderButton.tsx';
import PageHeaderNavigationToggle from './internal/PageHeaderNavigationToggle.tsx';
import PageHeaderSeparator from './internal/PageHeaderSeparator.tsx';

export default Object.assign(Page, {
    Content: PageContent,
    Header: PageHeader,
    HeaderTitle: PageHeaderTitle,
    HeaderBreadcrumb: PageHeaderBreadcrumb,
    HeaderSeparator: PageHeaderSeparator,
    HeaderButton: PageHeaderButton,
    HeaderIconButton: PageHeaderIconButton,
    HeaderNavigationToggle: PageHeaderNavigationToggle,
});
